import { LoanApplicantIdDocumentType } from '@servicetitan/financing-api-client';

export const extractLocation = (applicantId: any): { label: string; name: string } => {
    const countryTypes = [
        LoanApplicantIdDocumentType.MilitaryId,
        LoanApplicantIdDocumentType.Passport,
    ];
    const stateTypes = [
        LoanApplicantIdDocumentType.DriversLicense,
        LoanApplicantIdDocumentType.StateId,
    ];
    const idType = applicantId?.applicantIdDocumentType;
    const idIssueLocation = { label: '', name: '' };

    if (idType && stateTypes.includes(idType)) {
        idIssueLocation.label = 'ID State';
        idIssueLocation.name = applicantId?.state;
    } else if (idType === LoanApplicantIdDocumentType.Visa) {
        idIssueLocation.label = 'ID Government Branch';
        idIssueLocation.name = applicantId?.governmentBranch;
    } else if (idType && countryTypes.includes(idType)) {
        idIssueLocation.label = 'ID Country';
        idIssueLocation.name = applicantId.country;
    }

    return idIssueLocation;
};
